/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TCreateMessageFromEstimationRequest,
  TCreateMessageFromEstimationModel,
  IMappers,
  TCreateMessageFromEstimationResponse,
  TCreateMessageFromEstimationResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createCreateMessageFromEstimationModel(
  parameters: TCreateMessageFromEstimationRequest,
): TCreateMessageFromEstimationModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'price-estimator',
    pathApi: '/v1/create-message-from-estimation/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ICreateMessageFromEstimationOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCreateMessageFromEstimationRequest;
}

export async function fetchCreateMessageFromEstimation<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICreateMessageFromEstimationOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCreateMessageFromEstimationResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCreateMessageFromEstimationModel(parameters),
    config,
  )) as FetchResponse<TCreateMessageFromEstimationResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TCreateMessageFromEstimationResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCreateMessageFromEstimationResponse>;
}
